export enum AppCategory {
  Default = 0,
  Qbis = 1,
  Billogram = 2,
  Jobbile = 3,
  Stripe = 4,
  VismaAdvisor = 5,
}
